var map = {
	"./fauna/butterfly.svg": "e937",
	"./other/calender_date.svg": "5074",
	"./other/default_location_marker.svg": "3d53",
	"./other/design.svg": "bd85",
	"./other/exposition.svg": "a63f",
	"./other/family.svg": "afad",
	"./other/feedback.svg": "c9f3",
	"./other/feedback_negative.svg": "431b",
	"./other/growth_period.svg": "a7b0",
	"./other/interaction_bad.svg": "85e8",
	"./other/interaction_good.svg": "2864",
	"./other/interaction_none.svg": "cd35",
	"./other/interaction_very_bad.svg": "1761",
	"./other/interaction_very_good.svg": "ef2f",
	"./other/invasive.svg": "82f0",
	"./other/local.svg": "e026",
	"./other/location.svg": "a3dc",
	"./other/pen.svg": "6fd2",
	"./other/plant_height.svg": "d8f3",
	"./other/premade.svg": "882a",
	"./other/premade_disabled.svg": "5187",
	"./other/question_bubbles.svg": "5b3d",
	"./other/soil.svg": "3ac0",
	"./other/sowing_hand.svg": "a0781",
	"./other/vgarden.svg": "55c8",
	"./plants/Achillea.svg": "adde",
	"./plants/Actinidia chinensis.svg": "ecc5",
	"./plants/Allium ampeloprasum.svg": "e0ae",
	"./plants/Allium cepa var. aggregatum.svg": "626c",
	"./plants/Allium cepa.svg": "0c2c",
	"./plants/Allium sativum.svg": "e211",
	"./plants/Allium schoenoprasum.svg": "7597",
	"./plants/Anethum graveolens.svg": "3963",
	"./plants/Angelica.svg": "95b5",
	"./plants/Anthriscus cerefolium.svg": "fdb9",
	"./plants/Apium graveolens var. dulce.svg": "e895",
	"./plants/Apium graveolens var. rapaceum.svg": "85ba",
	"./plants/Armoracia rusticana.svg": "c97d",
	"./plants/Artemisia absinthium.svg": "25eb",
	"./plants/Artemisia dracunculus.svg": "1a0a",
	"./plants/Artemisia vulgaris.svg": "db8f",
	"./plants/Asparagus officinalis.svg": "0268",
	"./plants/Atriplex hortensis.svg": "3b5a",
	"./plants/Avena sativa.svg": "02ef",
	"./plants/Beta vulgaris ssp. vulgaris.svg": "33b8",
	"./plants/Beta vulgaris var. cicla.svg": "32f0",
	"./plants/Borago officinalis.svg": "4bcf",
	"./plants/Brassica juncea.svg": "d909",
	"./plants/Brassica napus subsp. rapifera.svg": "ba3a",
	"./plants/Brassica oleracea var. botrytis.svg": "99c3",
	"./plants/Brassica oleracea.svg": "2ca7",
	"./plants/Brassica oleracea var. gemmifera.svg": "5a22",
	"./plants/Brassica oleracea var. gongylodes.svg": "c461",
	"./plants/Brassica oleracea var. italica.svg": "14f7",
	"./plants/Brassica rapa subsp. pekinensis.svg": "03ae",
	"./plants/Brassica rapa var. rapa.svg": "dd95",
	"./plants/Calendula officinalis.svg": "530b",
	"./plants/Capsicum annuum.svg": "62df",
	"./plants/Capsicum annuum_poivron.svg": "6579",
	"./plants/Carum carvi.svg": "4bb6",
	"./plants/Chamaemelum nobile.svg": "3d28",
	"./plants/Cichorium endivia var. latifolium.svg": "30f8",
	"./plants/Cichorium endivia.svg": "e22d",
	"./plants/Cichorium.svg": "2fd3",
	"./plants/Citrullus lanatus var. lanatus.svg": "3434",
	"./plants/Citrus.svg": "d97b",
	"./plants/Citrus limon.svg": "c0ac",
	"./plants/Coriandrum sativum.svg": "46aa",
	"./plants/Crocus sativus.svg": "97db",
	"./plants/Cucumis anguria.svg": "7a9b",
	"./plants/Cucumis melo.svg": "01e6",
	"./plants/Cucumis sativus.svg": "c201",
	"./plants/Cucurbita pepo var. pepo.svg": "ba24",
	"./plants/Cucurbita pepo var. pepo_j.svg": "5e0d",
	"./plants/Cucurbita pepo var. ovifera.svg": "9d45",
	"./plants/Cucurbita.svg": "cf7a",
	"./plants/Cuminum cyminum.svg": "836d",
	"./plants/Cymbopogon citratus.svg": "1768",
	"./plants/Cynara cardunculus var. altilis.svg": "fe45",
	"./plants/Cynara cardunculus var. scolymus.svg": "98c9",
	"./plants/Dahlia pinnata.svg": "46c7",
	"./plants/Daucus carota.svg": "efe6",
	"./plants/Delphinium.svg": "1773",
	"./plants/Eruca vesicaria ssp. sativa.svg": "a2fc",
	"./plants/Euphorbia.svg": "1d6e",
	"./plants/Ficus carica.svg": "c8d6",
	"./plants/Foeniculum vulgare.svg": "3ce3",
	"./plants/Fragaria ananassa.svg": "f48f",
	"./plants/Gladiolus.svg": "c71c1",
	"./plants/Glycine max.svg": "2224",
	"./plants/Glycyrrhiza glabra.svg": "3dfc",
	"./plants/Helianthus annuus.svg": "1e80",
	"./plants/Helianthus tuberosus.svg": "a1e9",
	"./plants/Hordeum.svg": "e2fe",
	"./plants/Hosta.svg": "4635",
	"./plants/Hyssopus officinalis.svg": "aaa1",
	"./plants/Juglans regia.svg": "30a8",
	"./plants/Lactuca sativa.svg": "745e",
	"./plants/Lathyrus sativus.svg": "5464",
	"./plants/Laurus nobilis.svg": "0a1d",
	"./plants/Lavandula.svg": "ee4c",
	"./plants/Lens.svg": "ff32",
	"./plants/Levisticum officinale.svg": "aa65",
	"./plants/Linum usitatissimum.svg": "049b",
	"./plants/Lupinus.svg": "d69c",
	"./plants/Malus pumila.svg": "ab42",
	"./plants/Medicago sativa.svg": "058c",
	"./plants/Melissa officinalis.svg": "e6b2",
	"./plants/Mentha.svg": "cabe",
	"./plants/Morus.svg": "c65e",
	"./plants/Nasturtium officinale.svg": "1be9",
	"./plants/Ocimum basilicum.svg": "c329",
	"./plants/Origanum.svg": "25a5",
	"./plants/Pastinaca sativa.svg": "8004",
	"./plants/Petroselinum crispum.svg": "408a",
	"./plants/Petunia.svg": "0f57",
	"./plants/Phacelia.svg": "fbee",
	"./plants/Phaseolus vulgaris_Flageolet .svg": "04a8",
	"./plants/Phaseolus.svg": "7fef",
	"./plants/Pimpinella anisum.svg": "8726",
	"./plants/Pisum sativum.svg": "246a",
	"./plants/Poacées.svg": "2657",
	"./plants/Prunus armeniaca.svg": "7f8f",
	"./plants/Prunus avium.svg": "6a7e",
	"./plants/Prunus domestica.svg": "1c6f",
	"./plants/Prunus persica.svg": "1a75",
	"./plants/Pyrus communis.svg": "4a0b",
	"./plants/Raphanus sativus.svg": "e0dc",
	"./plants/Raphanus sativus var. niger.svg": "3611",
	"./plants/Rheum.svg": "e0c5",
	"./plants/Ribes nigrum.svg": "1e2c",
	"./plants/Ribes uva-crispa.svg": "a855",
	"./plants/Rosa hybrida.svg": "3168",
	"./plants/Rosmarinus officinalis.svg": "798a",
	"./plants/Rubus idaeus.svg": "2b9e",
	"./plants/Rumex acetosa.svg": "2ad6",
	"./plants/Ruta graveolens.svg": "cc50",
	"./plants/Salvia officinalis.svg": "45c2",
	"./plants/Satureja.svg": "916c",
	"./plants/Secale cereale.svg": "44a2",
	"./plants/Solanum lycopersicum.svg": "19db",
	"./plants/Solanum melongena.svg": "51e4",
	"./plants/Solanum tuberosum.svg": "34e4",
	"./plants/Sorghum bicolor.svg": "398d",
	"./plants/Spinacia oleracea.svg": "c7fb",
	"./plants/Symphytum officinale.svg": "c1b8",
	"./plants/Syringa vulgaris.svg": "b06a",
	"./plants/Tagetes patula.svg": "2d62",
	"./plants/Tanacetum vulgare.svg": "a6ca",
	"./plants/Taraxacum.svg": "7249",
	"./plants/Thymus vulgaris.svg": "121c",
	"./plants/Tragopogon porrifolius.svg": "ff52",
	"./plants/Trifolium.svg": "3cc2",
	"./plants/Trigonella foenum-graecum.svg": "822b",
	"./plants/Triticum.svg": "10be",
	"./plants/Tropaeolum.svg": "6b51",
	"./plants/Urtica.svg": "82fd",
	"./plants/Valerianella locusta.svg": "f3d5",
	"./plants/Vicia faba.svg": "49e4",
	"./plants/Vicia.svg": "127c",
	"./plants/Vigna unguiculata.svg": "3216",
	"./plants/Vitis vinifera.svg": "7d02",
	"./plants/Zea mays.svg": "f178",
	"./plants/default_flower.svg": "5706",
	"./plants/default_leaf.svg": "56e5",
	"./plants/exposition.svg": "db97",
	"./plants/myrtille.svg": "5ca2",
	"./tools/basket.svg": "a91e",
	"./tools/garden_trowel.svg": "a1bf",
	"./tools/garden_trowel_dark.svg": "5a7a",
	"./tools/shear.svg": "fd9e",
	"./tools/shovel.svg": "a795",
	"./tools/watering_can.svg": "f4e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";